import styled from 'styled-components';

export const ServicesContainer = styled.div`
  background: #2c3e4a;

  @media screen and (max-width: 768px) {
    padding: 10px 0;
  }
`;

export const ExpWrapper = styled.div`
  display: flex;
  flex-direction: column;
  z-index: 1;
  min-height: 600px;
  width: 100%;
  max-width: 1100px;
  margin-right: auto;
  margin-left: auto;
  padding: 0 24px;
`;

export const ServicesWrapper = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  align-items: center;
  grid-gap: 16px;
  // padding: 0 50px;
  padding-bottom: 50px;

  @media screen and (max-width: 1000px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 0 20px;
    padding-bottom: 50px;
  }
`;

export const ServicesCard = styled.div`
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 10px;
  height: 340px;
  padding: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease-in-out;

  &:hover {
    transform: scale(1.02);
    transition: all 0.2s ease-in-out;
  }
`;

export const ServicesIcon = styled.img`
  height: 160px;
  width: 160px;
  margin-bottom: 15px;
`;

export const ServicesH1 = styled.h1`
  font-size: 2.5rem;
  color: #fff;
  margin-top: 3.3rem;
  margin-bottom: 3.5rem;
  text-align: center;

  @media screen and (max-width: 480px) {
    font-size: 1.75rem;
    margin-top: 2.75rem;
  }
`;

export const ServicesH2 = styled.h2`
  font-size: 1.3rem;
  margin-bottom: 10px;
  text-align: center;
  color: ${({ color }) => ( color )};
`;

export const ServicesH3 = styled.h2`
  font-size: 1.15rem;
  margin-bottom: 10px;
  text-align: center;
  color: ${({ color }) => ( color )};

  // @media screen and (max-width: 480px) {
  //   font-size: 1rem;
  // }
`;

export const ServicesP = styled.p`
  font-size: 1.15rem;
  text-align: center;
  color: ${({ color }) => ( color )};

  // @media screen and (max-width: 480px) {
  //   font-size: 1rem;
  // }
`;
